function horizontal_scroll_block() {
    let element = document.querySelectorAll('body:not(.page-id-2947) .wp-block-columns:not(.supporting_logos):has(> :nth-child(6).wp-block-column), .product_types > div:not(.scrollBtns), .single-product .strip, .timeline > div');
    // console.log(element.length);

    if( element.length ) {

        element.forEach( element => {

            if( ! element.parentNode.querySelector('.scrollBtns') ) {

                // console.log(element);
                // console.log(! element.parentNode.querySelector('.scrollBtns'));
                
                let button = document.createElement('div'),
                    buttons = document.createElement('div'),
                    svg_icon = '<svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path d="M23.1 11.73a4.077 4.077 0 0 0-5.77.03l-2.87 2.89 9.53 9.44-6.66 6.72a4.077 4.077 0 0 0 .03 5.77l2.89 2.87 15.27-15.4-12.43-12.31Z"/></svg>';
                    scroll_distance = 400;

                    button.insertAdjacentHTML( 'beforeend', svg_icon );
                    buttons.classList.add('scrollBtns');
                    buttons.append(button);
                    buttons.append(button.cloneNode(true));

                if( element.scrollWidth > element.clientWidth ) {
                    element.after(buttons);
                    
                    buttons.querySelectorAll('div').forEach( btn => {
                        btn.addEventListener('click', () => {
                            if( btn == btn.parentNode.firstElementChild ) {
                                element.scrollLeft -= scroll_distance;
                            } else {
                                element.scrollLeft += scroll_distance;
                            }
                        });
                    });
                } else {
                    element.classList.add('no_scroll');
                }
                
            }
            
        });
    }
    
}

horizontal_scroll_block();